import { ExternalLink } from "lucide-react";
import fvoLogo from "@/assets/brands/fvo.png";
import oycLogo from "@/assets/brands/oyc.png";

/**
 * "Products I've Built" — apps Marquetta personally built.
 * Not peer businesses; these reinforce the operator-who-builds narrative.
 *
 * Fresh Vision OS: currently internal to FVR, licensing planned.
 * Own Your Credit: free DIY credit app, operated under MAI nonprofit.
 */
const ProductsBuilt = () => {
  const products = [
    {
      name: "Fresh Vision OS",
      status: "Powering Fresh Vision Realty",
      note: "Licensing coming soon",
      desc: "Agent operating system and CRM platform. Built from scratch for the FVR team after no commercial tool fit how a modern brokerage actually runs.",
      href: "https://app.freshvisionos.com",
      logo: fvoLogo,
    },
    {
      name: "Own Your Credit",
      status: "Free · Open to the public",
      note: "Operated under the MAI nonprofit",
      desc: "DIY credit repair app. Built to give families the same credit-building playbook Marquetta uses with clients, without the $2,000 credit-repair retainer.",
      href: "https://app.ownyourcredit.org",
      logo: oycLogo,
    },
  ];

  return (
    <section id="products-built" className="py-20 md:py-28 bg-[#F1EEE4] border-t border-[#C5A059]/15">
      <div className="container mx-auto px-6">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <p className="text-[0.7rem] md:text-[0.75rem] uppercase tracking-[0.25em] text-[hsl(var(--accent-strong))] font-semibold mb-4">
            Products I&apos;ve Built
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 leading-tight text-[#0A192F]">
            Software I Designed and Shipped
          </h2>
          <p className="text-[#0A192F]/75 text-base md:text-lg">
            Two apps built to solve problems Marquetta ran into firsthand. Not
            outsourced. Not templated.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {products.map((p) => (
            <a
              key={p.name}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col md:flex-row gap-6 bg-white border border-[#C5A059]/30 rounded-xl p-7 hover:border-[#C5A059] hover:shadow-[0_10px_40px_-15px_rgba(10,25,47,0.25)] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex-shrink-0 w-full md:w-32 h-24 md:h-32 flex items-center justify-center bg-white rounded-lg border border-[#C5A059]/20">
                <img
                  src={p.logo}
                  alt={`${p.name} logo`}
                  className="max-h-[80%] max-w-[85%] w-auto object-contain"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-[0.7rem] uppercase tracking-[0.2em] text-[hsl(var(--accent-strong))] font-semibold mb-1.5">
                  {p.status}
                </p>
                <h3 className="text-xl md:text-2xl font-bold mb-1 text-[#0A192F] leading-snug">
                  {p.name}
                </h3>
                <p className="text-xs text-[#0A192F]/55 italic mb-3">
                  {p.note}
                </p>
                <p className="text-[#0A192F]/75 text-sm md:text-[15px] leading-relaxed mb-4">
                  {p.desc}
                </p>
                <span className="inline-flex items-center gap-1.5 text-[hsl(var(--accent-strong))] font-semibold text-sm group-hover:gap-2.5 transition-all">
                  Visit
                  <ExternalLink className="w-3.5 h-3.5" strokeWidth={2} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsBuilt;
